import { produce } from 'immer';
import _ from 'lodash';

import { IS_PRODUCTION } from 'constants/envs';
import { COMPANY_INTERFIRST_ID } from 'constants/general';

import { COMPANIES_ACTION_TYPE } from '../actions';

const initialState = {};

const companiesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case COMPANIES_ACTION_TYPE.GET_COMPANIES:
        return _.omit(payload, !IS_PRODUCTION ? COMPANY_INTERFIRST_ID : undefined);

      case COMPANIES_ACTION_TYPE.GET_COMPANY:
      case COMPANIES_ACTION_TYPE.CREATE_COMPANY:
      case COMPANIES_ACTION_TYPE.EDIT_COMPANY:
        draft[payload.id] = payload;
        break;

      case COMPANIES_ACTION_TYPE.DELETE_COMPANY:
        delete draft[meta.companyId];
        break;

      default:
        return state;
    }
  });

export default companiesReducer;
